export default {
  list: [
    {
      title: 'صبحانه',
      value: 'BREAKFAST'
    },
    {
      title: 'ناهار',
      value: 'LUNCH'
    },
    {
      title: 'شام',
      value: 'DINNER'
    }
  ],
  values: {
    BREAKFAST: 'BREAKFAST',
    LUNCH: 'LUNCH',
    DINNER: 'DINNER'
  }
}